import React, {Fragment, useState, useEffect} from 'react'
import {Button} from 'react-bootstrap'
import '../Overview.css'
import Modal from 'react-bootstrap/Modal'
import Forms from './Form'
import UserService from '../../../../../services/user'
import useServices from '../../../../../utils/hooks/useServices'
import Dropdown from 'react-bootstrap/Dropdown'
import {toast} from 'react-toastify'
import Spinner from 'react-bootstrap/Spinner'
import {InitProfileData} from '../initProfileData'
import MasterServices from '../../../../../services/master'
import {useSearchParams} from 'react-router-dom'
import {PageTitle} from '_metronic/layout/core'
import {dateFormat} from 'thesis-and-dissertations/helpers/helper'

const Experience = () => {
  const [searchParams] = useSearchParams()
  const [show, setShow] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [formValue, setFormValue] = useState<any>({})
  const [submit, setSubmit] = useState(false)
  const [workingTypes, setWorkingTypes] = useState<any>([])
  const [industries, setIndustries] = useState<any>([])
  const [companies, setCompanies] = useState<any>([])
  const [companyOwnerships, setCompanyOwnerships] = useState<any>([])
  const [data, setData] = useState<any>({})
  const [dataUser, loading, makeItEmpty, triggerRefresh] = useServices(
    searchParams.get('alumni') ? MasterServices.showUser : UserService.getProfile,
    searchParams.get('alumni')
  )
  const [loadingDelete, setLoadingDelete] = useState(false)
  useEffect(() => {
    if (searchParams.get('alumni')) {
      setData(dataUser?.data)
    } else {
      setData(dataUser)
    }
  }, [dataUser])

  useEffect(() => {
    getWorkingType()
    getIndustries()
    getCompanies()
    getCompanyOwnership()
    return () => {
      makeItEmpty()
    }
  }, [])

  const toggle = () => {
    if (show) {
      setIsEdit(false)
      setFormValue({})
    }
    setShow(!show)
  }

  const onChange = (e: any) => {
    const {name, value} = e.target

    setFormValue({
      ...formValue,
      [name]: value,
    })
  }

  const handleDelete = async (id: any) => {
    try {
      if (!window.confirm('Yakin Ingin Menghapus Pengalaman ?')) {
        return
      }
      setLoadingDelete(true)
      setSubmit(true)

      await UserService.deleteExperience(id).then(() => {
        toast.success('Pengalaman berhasil dihapus')
        triggerRefresh()
      })
    } catch (error) {
      toast.success('Pengalaman gagal dihapus')
    } finally {
      setSubmit(false)
      setLoadingDelete(false)
    }
  }

  const getWorkingType = async (q = '') => {
    try {
      const {data} = await MasterServices.getWorkingType({...{is_active: 1}, q})
      setWorkingTypes(data.data)
    } catch (error) {
    }
  }

  const getCompanyOwnership = async (q = '') => {
    try {
      const {data} = await MasterServices.getCompanyOwnership({...{is_active: 1}, q})
      setCompanyOwnerships(data.data)
    } catch (error) {
    }
  }

  const getIndustries = async (q = '') => {
    try {
      const {data} = await MasterServices.getIndustry({...{is_active: 1}, q})
      setIndustries(data.data)
    } catch (error) {
    }
  }

  const getCompanies = async (q = '') => {
    try {
      const {data} = await MasterServices.getCompany({q})
      setCompanies(data.data)
    } catch (error) {
    }
  }
  return (
    <div>
      <Modal show={show} onHide={toggle} size='lg'>
        <Modal.Header closeButton>
          <Modal.Title>{isEdit ? 'Form' : 'Form'} Pengalaman</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Forms
            onChange={onChange}
            editFormValue={formValue}
            toggle={toggle}
            getData={triggerRefresh}
            industries={industries}
            companies={companies}
            workingTypes={workingTypes}
            companyOwnerships={companyOwnerships}
          />
        </Modal.Body>
      </Modal>
      <div className='row'>
        <div className='col-md-12'>
          <div className='row'>
            <div className='col-md-6'>
              {localStorage.getItem('role') == 'Alumni' && (
                <PageTitle
                  breadcrumbs={[
                    {
                      title: 'Dashboard',
                      path: '/dashboard',
                      isSeparator: false,
                      isActive: false,
                    },
                    {
                      title: '/',
                      path: '',
                      isSeparator: false,
                      isActive: false,
                    },
                  ]}
                >
                  Pengalaman Kerja
                </PageTitle>
              )}
              <h4>Pengalaman Kerja</h4>
            </div>
            <div className='col-md-6'>
              {!searchParams.get('alumni') && (
                <Button
                  onClick={toggle}
                  className='btn btn-primary btn-sm btn-add'
                  style={{float: 'right'}}
                >
                  Tambah
                </Button>
              )}
            </div>
          </div>
        </div>
        {/* start data alamat KTP */}
        <div className='col-md-12 d-grid gap-10'>
          <div style={{textAlign: 'center'}}>
            {loading && (
              <Spinner animation='border' role='status' style={{height: '100px', width: '100px'}} />
            )}
            {!loading && data?.experiences?.length === 0 && <h3>Tidak ada data Pengalaman </h3>}
          </div>
          {data?.experiences?.map((item: any) => {
            return (
              <Fragment key={item}>
                <div className='card-custom'>
                  <div className='row'>
                    <div className='col-md-6 p-2'>
                      <h5>{item?.user_experiences_title}</h5>
                    </div>
                    <div className='col-md-6'>
                      {!searchParams.get('alumni') && (
                        <Dropdown>
                          <Dropdown.Toggle
                            id='dropdown-basic'
                            style={{float: 'right'}}
                            className='btn btn-primary btn-sm'
                          >
                            Aksi
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item
                              href='#/action-1'
                              onClick={() => {
                                setIsEdit(true)
                                setFormValue({
                                  title: item?.user_experiences_title,
                                  company_name: item?.user_experiences_company_name,
                                  start_date: item?.user_experiences_start_date,
                                  end_date: item?.user_experiences_end_date,
                                  industries: item.industry?.industries_name,
                                  description: item?.user_experiences_description,
                                  company_ownerships_id:
                                    item?.company?.company_ownership?.company_ownerships_id,
                                  rowDetail: item,
                                })
                                toggle()
                              }}
                            >
                              Edit
                            </Dropdown.Item>
                            <Dropdown.Item
                              href='#/action-2'
                              onClick={() => {
                                handleDelete(item?.user_experiences_id)
                              }}
                            >
                              Hapus
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      )}
                    </div>
                    <div className='col-md-12'>
                      <div className='col-md-12'>
                        <div className='row'>
                          <div className='col-md-6 p-2'>
                            <p>Jenis Pekerjaan</p>
                            <p className='fw-bold'>{item.working_type?.working_types_name}</p>
                          </div>
                          <div className='col-md-6 p-2'>
                            <p>Nama Perusahaan</p>
                            <p className='fw-bold'>
                              {item?.user_experiences_company_name}
                              {item?.company?.company_ownership?.company_ownerships_name
                                ? ` (${item?.company?.company_ownership?.company_ownerships_name})`
                                : null}
                            </p>
                          </div>
                          <div className='col-md-6 p-2'>
                            <p>Awal Bekerja</p>
                            <p className='fw-bold'>
                              {item?.user_experiences_start_date
                                ? dateFormat(item?.user_experiences_start_date)
                                : '-'}
                            </p>
                          </div>
                          <div className='col-md-6 p-2'>
                            <p>Akhir Bekerja</p>
                            <p className='fw-bold'>
                              {item?.user_experiences_end_date
                                ? dateFormat(item?.user_experiences_end_date)
                                : 'Saya Masih Bekerja'}
                            </p>
                          </div>
                          <div className='col-md-12 p-2'>
                            <p>Industri</p>
                            <p className='fw-bold'>{item.industry?.industries_name}</p>
                          </div>
                          <div className='col-md-12 p-2'>
                            <p>Deskripsi Pekerjaan</p>
                            <p className='fw-bold'>{item?.user_experiences_description || '-'}</p>
                          </div>

                          {item?.document_url_full && item?.user_experiences_end_date ? (
                            <div className='col-md-12 p-2'>
                              <p>Dokumen Pendukung</p>
                              <a
                                href={item?.document_url_full}
                                target='_blank'
                                className='btn btn-primary btn-sm'
                              >
                                Paklaring
                              </a>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Fragment>
            )
          })}
        </div>
        {/* end data alamat KTP */}
        {/* end content */}
      </div>
    </div>
  )
}

export default Experience
